import React from 'react';
import useWindowSize from '@utils/useWindowSize';
import maxWidth from '@assets/variables/screen-sizes';
import styles from './ApplicationLogo.module.scss';

function ApplicationLogo() {
  const { width } = useWindowSize();
  const isBiggerThanMobile = width > maxWidth.mobile;

  return isBiggerThanMobile ? (
    <img className={styles.logo} src="/images/sailor_icon_white_256.png" alt="SAILOR logo" />
  ) : null;
}

export default ApplicationLogo;
